import request from '@/utils/request'

function findAllByCellphone (cellphone) {
  return request({
    url: `/pos/payer?cellphone=${cellphone}`,
    method: 'get'
  })
}

export default {
  findAllByCellphone
}
